import { useFeatureAvailable, Feature } from 'App/components/hooks/featureHelper';

export default function allowed() {
	return useFeatureAvailable(Feature.ADVANCED_SEARCH);
}
